<template>
  <div id="kc_ds_container" style="padding-top: 70px;">
    <div class="kc_ds_info">
      <div class="cnt">
        <img :src="courseInfo.thumb">
        <div class="ds_info_fr">
          <h2 style="margin-left: 30px">{{courseInfo.title}}</h2>
          <span class="ds_nums">
            <span class="span1" v-if="courseInfo.trainCourseAnalysis!=undefined">
              <i class="ds_i_at"></i>
              <span class="ds-i-r"> 学习人数 {{courseInfo.trainCourseAnalysis['studentNum']}}</span>
            </span>
            <br>
            <span style="font-size: 16px;margin-top: 20px; display: block; color: #333;">主讲人:
              {{courseInfo.teacherName}}</span>
          </span>
          <div class="ds_info_op ds_info_op1">
            <a id="continueLearn" class="ds_q_at"
              v-if="userInfo!= null && courseInfo.periodRecords !== undefined  && courseInfo.periodRecords.length>0"
              @click="startLearn()"> 继续学习</a>
            <a id="continueLearn" class="ds_q_at" v-else @click="startLearn()"> 开始学习</a>
            <div class="shareModel">
              <span class="qaaCollection00" v-if="courseInfo.isCollect" @click="Collect()">
                <span class="qaaCollection ischoosed"></span> <span class="qaaCollection2">取消收藏</span><span
                  class="qaaCollection1 ischoosed">收藏</span>
              </span>
              <span class="qaaCollection00" v-else @click="Collect()">
                <span class="qaaCollection"></span> <span class="qaaCollection2 ischoosed">取消收藏</span> <span
                  class="qaaCollection1">收藏</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ks_ds_pannel">
      <div class="cnt">
        <div class="ks_ds_fl">
          <div class="ks_ds_desc">
            <div class="ks_ds_tabs">
              <div class="ks_ds_tb_op">
                <a :class="[ showIndex==0?'active':'']" @click="setIndex(0)">课程目录</a>
                <a :class="[ showIndex==1?'active':'']" @click="setIndex(1)">课程简介</a>
                <a :class="[ showIndex==2?'active':'']" @click="setIndex(2)">资料下载</a>
                <a :class="[ showIndex==3?'active':'']" @click="setIndex(3)">问答评论</a>
              </div>
            </div>
          </div>
          <div class="kc_detail">
            <div v-show="ifDeadLine" :class="[ showIndex==0?'active':'','ks_ds_tb_item']" id="kc_ds_tab_div2">
              <div class="ks_ds_list">
                <div class="ke_sections" v-for="item in courseInfo.courseSections">
                  <div class="ks_ds_ml_chapter">
                    <span class="span1">章节</span>
                    <span class="span2">{{item.seq}}</span>
                    <span class="span3">{{item.title}} </span>
                  </div>
                  <div class="ks_ds_ml_periods continueStudy" v-for="item1 in item.trainPeriods"
                    @click="viewVideo(item1.id)">
                    <div :class="[item1.btnstate=='finished'?'finished':'',item1.btnstate=='unfinished'?'Ongoing':'',item1.btnstate=='start'?'unstart':'','ks_ds_ml_period']">
                      <span class="span1">课时 {{item1.seq}} </span>
                      <span class="span2"></span>
                      <span class="span3">{{item1.title}}</span>
                      <div class="fr">
                        <a class="span4">
                          <span v-if="item1.btnstate=='start'" class="bn" @click="viewVideo(item1.id)">开始学习</span>
                          <span v-else-if="item1.btnstate=='finished'" class="bn"
                            @click="viewVideo(item1.id)">已完成</span>
                          <span v-else class="bn" @click="viewVideo(item1.id)">继续学习</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div :class="[ showIndex==1?'active':'','ks_ds_tb_item']" id="kc_ds_tab_div1" style="padding: 20px 0">
              <div class="desc">{{courseInfo.summary}}</div>
            </div>
            <div :class="[ showIndex==2?'active':'','ks_ds_tb_item']" id="kc_ds_tab_div4"
              style="background:#f3f3f3;  padding:20px 0px 10px;margin-top: 20px;">
              <div class="fileList">
                <div class="fitem" v-for="fitem in courseInfo.resourceDtos">
                  <span class="ftype pdf "></span>
                  <span class="fname">{{fitem.fileName}}</span>
                  <span class="size">{{(fitem.fileSize/1024/1024).toFixed(2)}}MB</span>
                  <span class="createtime">{{fitem.creationTime  | dateFormat("YYYY-MM-DD")}}</span>
                  <a @click="downFile(fitem)" style="color: #555;">下载</a>
                </div>
                <div class="nodata" v-if="courseInfo.resourceDtos!=undefined && courseInfo.resourceDtos.length==0">
                  <span class="nodata-img"></span>
                  <span class="nodata-txt">没有找到数据</span>
                </div>
              </div>
            </div>
            <div :class="[ showIndex==3?'active':'','ks_ds_tb_item']" id="kc_ds_tab_div3"
              style="padding:0;   margin-top: 20px;background:#f3f3f3">
              <h2 class="h-title" v-show="operationStep==0"><span class="tabs"><a
                    :class="[fabutype=='question'?'active':'']" @click="setType('question')">问答</a><a
                    :class="[fabutype=='pinglun'?'active':'']" @click="setType('pinglun')">评论</a></span><button
                  class="btn_fabu" @click="fabufun()">我要发布</button> </h2>
              <div class="plList" id="questionList" v-show="operationStep==0 && fabutype=='question'">
                <div class="list">
                  <div class="qitem type-q" v-for="qitem in questionList" @click="viewReplyList(qitem)">
                    <div class="uft">
                      <img :src="qitem.headImg" class="h_img">
                      <span class="u-name">{{qitem.userName}}</span>
                    </div>
                    <div class="urt">
                      <div class="pretxt">
                        <span class="comtxt"> {{qitem.comments}} </span>
                        <!-- <button class="Reply_btn" v-if="userInfo.id != qitem.createUserId">我来回答{{qitem.createUserId}}</button> -->
                      </div>
                      <span class="num"><span class="annswerNum"><span
                            style="display: inline;margin: 0">{{qitem.replyNum}}</span>回答</span>
                        <span class="viewcount">{{qitem.viewsCount}}浏览</span>
                      </span>
                    </div>
                  </div>
                  <div class="nodata" v-if="questionList.length==0"><span class="nodata-img"></span><span
                      class="nodata-txt">没有找到数据</span></div>
                </div>
                <div class="more_c" id="questionMore"
                  v-if="questionList.length > 0 && postdata.question.total > questionList.length"
                  @click="getquestions()">
                  查看更多
                </div>
              </div>
              <div class="plList" id="plList" v-show="operationStep==0 && fabutype=='pinglun'">
                <div class="list">
                  <div class="qitem2 type-p" v-for="item in pinglunList">
                    <div class="uft"> <img :src="item.user.headImage" class="h_img"> </div>
                    <div class="urt">
                      <div class="pretxt"> <span class="u-name"
                          style="margin-bottom: 10px;">{{item.user.fullName}}</span> <span class="comtxt">
                          {{item.content}} </span> </div>
                    </div>
                  </div>
                  <div class="nodata" v-if="pinglunList.length==0"><span class="nodata-img"></span><span
                      class="nodata-txt">没有找到数据</span></div>
                </div>
                <div class="more_c" id="pinglunMore"
                  v-if="pinglunList.length > 0 && postdata.pinglun.total > pinglunList.length" @click="getpinglun()">
                  查看更多
                </div>
              </div>
              <div class="plList" id="form-div" v-show="operationStep==2 && fabutype=='question'">
                <div class="div1"><span>问答评论</span> &gt; <a class="allquestion"
                    @click="chooseType('question',0)">全部问答</a> &gt; <a>我要提问</a></div>
                <div class="submit-box">
                  <h2><img src="/Images/new/createQ.png" style="width:24px;"><span>我要提问</span></h2>
                  <div class="">
                    <textarea class="question-txt" v-model="questionTxt"></textarea>
                    <button class="submit-question" @click="submitQuestion()">提交</button>
                  </div>
                </div>
              </div>
              <div class="plList" id="form-div" v-show="operationStep==2 && fabutype=='pinglun'">
                <div class="div1"><span>问答评论</span> &gt; <a class="allpinglun" @click="chooseType('pinglun',0)">全部评论</a>
                  &gt; <a>我要评论</a></div>
                <div class="submit-box">
                  <h2><img src="/Images/new/createP.png" style="width:24px;"><span>我要评论</span></h2>
                  <div class="">
                    <textarea class="ds_ev_content" v-model="pinglunTxt"></textarea>
                    <a class="ds_ev_tn_submit" @click="submitPinglun()">提交</a>
                  </div>
                </div>
              </div>
              <div class="plList" id="info-div" v-if="operationStep == 3 ">
                <div class="div1"><span>问答评论</span> &gt; <a class="allquestion"
                    @click="chooseType('question',0)">全部问答</a> &gt; <a>我要提问</a></div>
                <div class="plInfo">
                  <h2>问答</h2>
                  <div class="qitem2">
                    <div class="uft"> <img :src="ReplyPage.headImg" class="h_img"> <span
                        class="u-name">{{ReplyPage.userName}}</span> </div>
                    <div class="urt">
                      <div class="pretxt">
                        <span class="comtxt"> {{ReplyPage.comments}} </span>
                        <button class="Reply_btn" v-if="userInfo!=null && userInfo.id != ReplyPage.createUserId"
                          @click="setType('reply')">我来回答</button>
                      </div>
                      <span class="num">
                        <span class="annswerNum"> <span
                            style="display: inline;margin: 0">{{ReplyPage.replyNum}}</span>回答</span><span
                          class="viewcount">{{ReplyPage.viewsCount}}浏览</span></span>
                    </div>
                  </div>
                </div>
                <div class="replylist">
                  <div :class="[citem.isAdoption?'Adoption':'','ritem'] " v-for="citem in ReplyPage.childQuestion">
                    <span class="uinfo">
                      <img :src="citem.headImg">
                      <span class="uname">{{citem.userName}}</span>
                    </span>
                    <span class="comtxt">{{citem.comments}}</span>
                    <button class="adpat" v-if="userInfo!=null &&  userInfo.id == ReplyPage.createUserId"
                      @click="adpatQuestion(citem)">采纳为最佳答案</button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="ks_ds_fr">
          <div class="ks_ds_ev">
            <h2>讲师简介</h2>
            <div class="kedesc">
              <span class="tname">{{courseInfo.teacherName}}</span> <br>
              <span class="timg">
                <img v-if="courseInfo.teacherHeadImg!=null" :src="courseInfo.teacherHeadImg">
                <img v-else src="images/default-user-headimage.jpg" />
              </span>
              <br>
              <span class="tinfo">{{courseInfo.teacherInfo}}</span></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 我要发布 -->
    <div :class="[operationStep==1?'in':'','modal','fade']" id="fabu-modal"
      :style="{display:(operationStep==1?'block':'none')}">
      <div class="modal-dialog" role="document">
        <div class="modal-header" style="border-bottom:1px solid #ccc">
          <span class="title">我要发布</span>
          <button type="button" class="close" @click="setStep(0)"><span>×</span></button>
        </div>
        <div class="modal-body">
          <div class="fb_item">
            <button class="createQ" @click="chooseType('question',2)">
              <img src="/Images/new/createQ.png">
              <span class="ft">
                <span class="t">我要提问</span>
                <span class="tishi">将学习过程中遇到的关于课程资料、学习方法等问题，课程讲师或同学 会为你答疑解惑。</span>
              </span>
            </button>
          </div>
          <div class="fb_item">
            <button class="createP" @click="chooseType('pinglun',2)">
              <img src="/Images/new/createP.png">
              <span class="ft">
                <span class="t">我要评论</span>
                <span class="tishi">您可以将自己学习过程中的心得等分享到这里， 与大家一起共同进步。</span>
              </span>
            </button>
          </div>
        </div>

      </div>
    </div>
    <div :class="[fabutype=='reply'?'in':'','modal','fade']" id="replay-modal"
      :style="{display:(fabutype=='reply'?'block':'none')}">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="margin-top:200px;">
          <div class="modal-header" style="border-bottom:1px solid #ccc">
            <span class="title">回复</span>
            <button type="button" @click="setType('question') " class="close"><span>×</span></button>
          </div>
          <div class="modal-body">
            <h2 style="margin-bottom: 12px;display:inline-block">回复内容：</h2>
            <textarea class="question-txt replay-txt" v-model="replyTxt"></textarea>
          </div>
          <div class="modal-footer">
            <button class="cancel-replay" @click="setType('question')">取消</button> <button class="replay-question"
              @click="submitReply()">提交</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="operationStep==1 || fabutype=='reply'" class="modal-backdrop fade in shadowbox"></div>
  </div>
</template>

<script>
  import comFun from "@/common/common";
  //  import '@/plugins/element.js'
  export default {
    name: "",
    components: {},
    filters: {
      dateFormat(dateStr, pattern = '') {
        var dt = new Date(dateStr)
        var yy = dt.getFullYear()
        var mm = (dt.getMonth() + 1).toString().padStart(2, '0')
        var dd = dt.getDate().toString().padStart(2, '0')
        var h = dt.getHours().toString().padStart(2, '0')
        var m = dt.getMinutes().toString().padStart(2, '0')
        var s = dt.getSeconds().toString().padStart(2, '0')
        if (pattern.toLowerCase() === 'yyyy-mm-dd') {
          return yy + '-' + mm + '-' + dd
        } else if (pattern.toLowerCase() === 'yyyy-mm-dd hh:mm') {
          return yy + '-' + mm + '-' + dd + ' ' + h + ':' + m
        } else if (pattern.toLowerCase() === 'hh:mm') {
          return h + ':' + m
        } else {
          return yy + '-' + mm + '-' + dd + ' ' + h + ':' + m + ':' + s
        }
      }
    },
    data() {
      return {
        ifDeadLine: true,
        showIndex: 0,
        courseInfo: {
          trainCourseAnalysis: {
            studentNum: 0
          }
        },
        operationStep: 0,
        fabutype: "question",
        questionList: [],
        pinglunList: [],
        questionTxt: '',
        pinglunTxt: '',
        replyTxt: '',
        postdata: {
          question: {
            TrainCourseId: this.$route.query.id,
            MaxResultCount: 5,
            pageIndex: 0,
            Sorting: "Id desc",
            total: 0
          },
          pinglun: {
            CourseId: this.$route.query.id,
            maxResultCount: 5,
            sorting: "CreationTime desc",
            pageIndex: 0,
            courseType: 3,
            total: 0
          }
        },
        ReplyPage: {},
        courseId: 0
      };
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
    },
    watch: { // 监听事件
      userInfo(newName) {
        this.getInfo()
      }
    },
    mounted() {
      this.courseId = this.$route.query.id
      this.getInfo()
      this.getquestions()
      this.getpinglun()
    },
    methods: {
      getInfo() {
        //var id = this.$route.query.id
        //comFun.getDeadLine(this.classId,this.courseId);
        //alert(this)
        comFun.getCourseInfo(this.courseId).then(res => {
          this.courseInfo = res;
          // debugger;
          //if(new Date(res.deadLine) < new Date())
          //  this.ifDeadLine = false;
          this.courseInfo.courseSections.forEach(element => {
            element.trainPeriods.forEach(element1 => {
              if (this.courseInfo.periodRecords.length == 0) {
                element1.btnstate = 'start'
              } else if (!this.courseInfo.periodRecords.some(s => s.periodId == element1.id)) {
                element1.btnstate = 'start'
              } else {
                var a = this.courseInfo.periodRecords.find(s => s.periodId == element1.id)
                if (a.status == 1) {
                  element1.btnstate = 'finished'
                } else {
                  element1.btnstate = 'unfinished'
                }
              }
            })
          });
          // console.log(this.courseInfo.courseSections)
        })
      },
      Collect() { //收藏方法
        if (!this.validLogined()) return false
        var postdata = {
          CourseId: this.courseId,
          CourseType: 3
        }
        comFun.CreateTrainCollect(postdata).then(res => {
          if (res.success) {
            var str = ''
            this.courseInfo.isCollect = !this.courseInfo.isCollect
            if (this.courseInfo.isCollect) str = '收藏成功'
            else str = '取消收藏成功'
            var msg = {
              type: 'success',
              text: str
            }
            this.$store.dispatch('setMsg', msg)
          }
        })
      },
      setIndex(index) { // 切换方法
        this.showIndex = index
      },
      startLearn() { // 开始学习  继续学习按钮 方法
        var pid = 0
        if (!this.validLogined()) return false
        if (this.courseInfo.periodRecords !== undefined && this.courseInfo.periodRecords.length > 0) { // 继续学习
          pid = this.courseInfo.periodRecords[0].periodId
          // console.log(pid)
        } else { //开始学习
          if (this.courseInfo.courseSections[0].trainPeriods[0].id !== undefined) {
            pid = this.courseInfo.courseSections[0].trainPeriods[0].id
          } else {
            var msg = {
              type: 'error',
              text: '没有获取正确的单元信息'
            }
            this.$store.dispatch('setMsg', msg)
          }
        }
        this.previewVideo(pid)
      },
      viewVideo(id) { // 浏览课时方法
        if (!this.validLogined()) return false
        this.previewVideo(id)
      },
      validLogined() { //验证是否登录
        if (this.userInfo == null) {
          this.$store.dispatch('setShowLogin', true)
          return false;
        } else {
          return true
        }
      },
      async previewVideo(id) { // 打开课时预览页面
        var output = await comFun.IsJoinCourse(this.courseId)
        if (!output.isJoin) {
          var msg = {
            type: 'error',
            text: '对不起，您没有权限访问！'
          }
          this.$store.dispatch('setMsg', msg)
        } else {
          window.open("/TrainCourse/TrainCourseVideo?PeriodId=" + id + "&CourseId=" + this.courseId);
        }
      },
      async downFile(item) { // 下载文档
        if (!this.validLogined()) return false
        var output = await comFun.IsJoinCourse(this.courseId)
        if (!output.isJoin) {
          var msg = {
            type: 'error',
            text: '对不起，您没有权限访问！'
          }
          this.$store.dispatch('setMsg', msg)
        } else {
          window.open(item.fileUrl, '_blank')
        }

        // fetch(item.fileUrl).then(res => res.blob().then(blob => {
        //   let link = document.createElement("a");

        //   link.download = item.fileName;
        //   link.href = window.URL.createObjectURL(blob);
        //   link.style.display = "none";
        //   link.click();
        //   window.URL.revokeObjectURL(item.fileName);
        // }));
      },
      async getquestions() {
        var questionArr = await comFun.getQuestions(this.postdata.question)
        for (let index = 0; index < questionArr.items.length; index++) {
          const element = questionArr.items[index];
          questionArr.items[index].childQuestion = await comFun.getChildQuestions(element.id)
          questionArr.items[index].replyNum = questionArr.items[index].childQuestion.length
        }
        this.postdata.question.total = questionArr.totalCount
        this.questionList = this.questionList.concat(questionArr.items)
        this.postdata.question.pageIndex++;
      },
      getpinglun() {
        comFun.getEvaluationPageListByCourseId(this.postdata.pinglun).then(res => {
          this.postdata.pinglun.total = res.totalCount
          this.pinglunList = this.pinglunList.concat(res.items)
          this.postdata.pinglun.pageIndex++;
        })

      },
      setType(type) {
        this.fabutype = type
      },
      setStep(index) {
        this.operationStep = index
      },
      chooseType(type, index) {
        this.fabutype = type
        this.operationStep = index
      },
      submitQuestion() {
        var postdata = {
          Comments: this.questionTxt,
          ParentId: 0,
          TrainCourseId: this.courseId,
          ReplyToUserId: this.userInfo.id,
          ViewsCount: 0
        }
        comFun.submitQuestion(postdata).then(res => {
          this.questionList = []
          this.postdata.question.pageIndex = 0
          this.getquestions()
          this.operationStep = 0;
          this.questionTxt = ''
        })

      },
      submitPinglun() {
        var postdata = {
          CourseId: this.courseId,
          Content: this.pinglunTxt,
          CourseType: 3,
          Score: 5
        }
        comFun.submitPinglun(postdata).then(res => {
          this.operationStep = 0;
          this.pinglunList = []
          this.postdata.pinglun.pageIndex = 0
          this.getpinglun()
          this.pinglunTxt = ''
        })
      },
      submitReply() {
        var postdata = {
          Comments: this.replyTxt,
          ParentId: this.ReplyPage.id,
          TrainCourseId: this.courseId,
          ReplyToUserId: this.userInfo.id,
          ViewsCount: 0
        }
        comFun.submitQuestion(postdata).then(async res => {
          this.fabutype = "question"
          this.ReplyPage.childQuestion = await comFun.getChildQuestions(this.ReplyPage.id)
          this.replyTxt = ''
        })
      },
      async viewReplyList(item) { // 查看问答详情
        // 更新浏览
       if(item.createUserId != this.userInfo.id) item.viewsCount = await comFun.UpdateQuestionViewCount(item.id)
        this.operationStep = 3
        this.ReplyPage = item

      },
      adpatQuestion(citem) {
        comFun.AdoptionCourseQuestion(this.courseId, citem.id).then(res => {
          comFun.getChildQuestions(this.ReplyPage.id).then(res => {
            this.ReplyPage.childQuestion = res
          })
        })
      },
      fabufun() {
        if (!this.validLogined()) return false
        this.setStep(1)
      }

    }
  };
</script>

<style scoped>

</style>